// extracted by mini-css-extract-plugin
module.exports = {"reseller-form__tos":"resellerForm-module__reseller-form__tos___Kcc6u"};